import AppointmentContainer from "@/Job/AppointmentContainer.vue";
import MarketingOutOfCoverageCustomersContainer from "@/Marketing/MarketingOutOfCoverageCustomersContainer.vue";
import PerformanceDashboard from "@/PerformanceDashboard/PerformanceDashboard.vue";
import AllReports from "@/Reports/AllReports.vue";
import BalanceDueIndex from "@/Reports/BalanceDueIndex.vue";
import BillingIndex from "@/Reports/BillingIndex.vue";
import CommissionReportIndex from "@/Reports/CommissionReportIndex.vue";
import EquipmentCaptureIndex from "@/Reports/EquipmentCaptureIndex.vue";
import EquipmentReportIndex from "@/Reports/EquipmentReportIndex.vue";
import FormsAndChecklistsIndex from "@/Reports/FormsAndChecklistsIndex.vue";
import IncomingCallsIndex from "@/Reports/IncomingCallsIndex.vue";
import JobCostsIndex from "@/Reports/JobCostsIndex.vue";
import JobsIndex from "@/Reports/JobsIndex.vue";
import JobTimesIndex from "@/Reports/JobTimesIndex.vue";
import LineItemsSoldIndex from "@/Reports/LineItemsSoldIndex.vue";
import MarketingContactReportIndex from "@/Reports/MarketingContactReportIndex.vue";
import MembersIndex from "@/Reports/MembersIndex.vue";
import OpportunitiesReportIndex from "@/Reports/OpportunitiesReportIndex.vue";
import OutstandingDrawsIndex from "@/Reports/OutstandingDrawsIndex.vue";
import PendingRevenueIndex from "@/Reports/PendingRevenueIndex.vue";
import PurchaseOrdersIndex from "@/Reports/PurchaseOrdersIndex.vue";
import QuotesIndex from "@/Reports/QuotesIndex.vue";
import RevenueIndex from "@/Reports/RevenueIndex.vue";
import SalesTaxReportIndex from "@/Reports/SalesTaxReportIndex.vue";
import WarrantiesTodoIndex from "@/Reports/WarrantiesTodoIndex.vue";
import TimeCardsReportIndex from "@/Timesheets/TimeCardsReportIndex.vue";

export default [
  {
    path: "/reports",
    name: "PerformanceDashboard",
    component: PerformanceDashboard,
    meta: {
      permissionRoles: ["financial_data"]
    }
  },
  {
    path: "/reports/appointments",
    name: "AppointmentContainer",
    component: AppointmentContainer,
    meta: {
      permissionRoles: ["appointment_list_report"]
    }
  },
  {
    path: "/reports/all",
    name: "AllReports",
    component: AllReports,
    meta: {
      permissionRoles: [
        "appointment_list_report",
        "job_times_report",
        "incoming_calls_report",
        "equipment_capture_report",
        "sold_line_items_report",
        "quoted_line_items_report",
        "balance_due_customers_report",
        "commissions_list_report",
        "batches_report",
        "purchase_orders_report",
        "outstanding_draws_report",
        "pending_revenue_report",
        "promo_codes_report",
        "sales_tax_report",
        "customer_contact_report",
        "equipment_report",
        "members_report",
        "opportunities_report",
        "out_of_coverage_report"
      ]
    }
  },
  {
    path: "/reports/balance_due",
    name: "BalanceDueIndex",
    component: BalanceDueIndex,
    meta: {
      permissionRoles: ["balance_due_customers_report"]
    }
  },
  {
    path: "/reports/billing",
    name: "BillingIndex",
    component: BillingIndex,
    meta: {
      permissionRoles: ["financial_data"]
    }
  },
  {
    path: "/reports/calls",
    name: "IncomingCallsIndex",
    component: IncomingCallsIndex,
    meta: {
      permissionRoles: ["incoming_calls_report"]
    }
  },
  {
    path: "/reports/commissions",
    name: "CommissionReportIndex",
    component: CommissionReportIndex,
    meta: {
      permissionRoles: ["commissions_list_report"]
    }
  },
  {
    path: "/reports/forms_and_checklists",
    name: "FormsAndChecklistsIndex",
    component: FormsAndChecklistsIndex,
    meta: {
      permissionRoles: ["forms_and_checklists_report"]
    }
  },
  {
    path: "/reports/equipment",
    name: "EquipmentReportIndex",
    component: EquipmentReportIndex,
    meta: {
      permissionRoles: ["equipment_report"]
    }
  },
  {
    path: "/reports/equipment_capture",
    name: "EquipmentCaptureIndex",
    component: EquipmentCaptureIndex,
    meta: {
      permissionRoles: ["equipment_capture_report"]
    }
  },
  // No permissionRoles: any admin may read it; only labor rates are role-gated.
  {
    path: "/reports/job_costs",
    name: "JobCostsIndex",
    component: JobCostsIndex
  },
  {
    path: "/reports/job_times",
    name: "JobTimesIndex",
    component: JobTimesIndex,
    meta: {
      permissionRoles: ["job_times_report"]
    }
  },
  {
    path: "/reports/jobs",
    name: "JobsIndex",
    component: JobsIndex,
    meta: {
      permissionRoles: ["jobs"]
    }
  },
  {
    path: "/reports/line_items_sold",
    name: "LineItemsSoldIndex",
    component: LineItemsSoldIndex,
    meta: {
      permissionRoles: ["sold_line_items_report"]
    }
  },
  {
    path: "/reports/marketing_contact",
    name: "MarketingContactReportIndex",
    component: MarketingContactReportIndex,
    meta: {
      permissionRoles: ["customer_contact_report"]
    }
  },
  {
    path: "/reports/members",
    name: "MembersIndex",
    component: MembersIndex,
    meta: {
      permissionRoles: ["members_report"]
    }
  },
  {
    path: "/reports/opportunities",
    name: "OpportunitiesReportIndex",
    component: OpportunitiesReportIndex,
    meta: {
      permissionRoles: ["opportunities_report"]
    }
  },
  {
    path: "/reports/outstanding_draws",
    name: "OutstandingDrawsIndex",
    component: OutstandingDrawsIndex,
    meta: {
      permissionRoles: ["outstanding_draws_report"]
    }
  },
  {
    path: "/reports/payroll",
    name: "PayrollReportIndex",
    component: TimeCardsReportIndex,
    meta: {
      permissionRoles: ["timecards"]
    }
  },
  {
    path: "/reports/pending_revenue",
    name: "PendingRevenueIndex",
    component: PendingRevenueIndex,
    meta: {
      permissionRoles: ["pending_revenue_report"]
    }
  },
  {
    path: "/reports/purchase_orders",
    name: "PurchaseOrdersIndex",
    component: PurchaseOrdersIndex,
    meta: {
      permissionRoles: ["purchase_orders_report"]
    }
  },
  {
    path: "/reports/quotes",
    name: "QuotesIndex",
    component: QuotesIndex,
    meta: {
      permissionRoles: ["quoting"]
    }
  },
  {
    path: "/reports/revenue",
    name: "RevenueIndex",
    component: RevenueIndex,
    meta: {
      permissionRoles: ["financial_data"]
    }
  },
  {
    path: "/reports/sales_tax",
    name: "SalesTaxReportIndex",
    component: SalesTaxReportIndex,
    meta: {
      permissionRoles: ["sales_tax_report"]
    }
  },
  {
    path: "/reports/time_cards",
    name: "TimeCardsReportIndex",
    component: TimeCardsReportIndex,
    meta: {
      permissionRoles: ["timecards"]
    }
  },
  {
    path: "/reports/warranties_todo",
    name: "WarrantiesTodoIndex",
    component: WarrantiesTodoIndex,
    meta: {
      permissionRoles: ["financial_data"]
    }
  },
  {
    path: "/interested_customers",
    name: "MarketingOutOfCoverageCustomersContainer",
    component: MarketingOutOfCoverageCustomersContainer,
    meta: {
      permissionRoles: ["out_of_coverage_report"]
    }
  }
];
